//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable implicit-arrow-linebreak */
import { mdiMagnify } from '@mdi/js'
import { computed, ref } from '@vue/composition-api'

export default {
  setup() {
    const knowledgeBaseSearchQuery = ref('')
    const kbContentData = [
      {
        character: require('@/assets/images/3d-characters/pose-f-3.png'),
        category: 'sales-automation',
        characterSize: '139',
        title: 'Sales Automation 👩🏻‍💻',
        desc: 'There is perhaps no better demonstration of the folly of image of our tiny world.',
      },
      {
        character: require('@/assets/images/3d-characters/pose-f-28.png'),
        category: 'marketing-automation',
        characterSize: '188',
        title: 'Marketing Automation 🚀',
        desc: 'Look again at that dot. That’s here. That’s home. That’s us. On it everyone you love.',
      },
      {
        character: require('@/assets/images/3d-characters/pose-m-34.png'),
        category: 'api-questions',
        characterSize: '126',
        title: 'API Questions 📱',
        desc: 'Every hero and coward, every creator and destroyer of civilization.',
      },
      {
        character: require('@/assets/images/3d-characters/pose-f-39.png'),
        category: 'email-marketing',
        characterSize: '172',
        title: 'Email Marketing ✉️',
        desc: 'There is perhaps no better demonstration of the folly of human conceits.',
      },
      {
        character: require('@/assets/images/3d-characters/pose-m-14.png'),
        category: 'personalization',
        characterSize: '163',
        title: 'Personalization 🤩',
        desc: 'It has been said that astronomy is a humbling and character experience.',
      },
      {
        character: require('@/assets/images/3d-characters/pose-m-5.png'),
        category: 'demand-generation',
        characterSize: '156',
        title: 'Demand Generation 🤟🏻',
        desc: 'Competent means we will never take anything for granted.',
      },
    ]

    const filteredKB = computed(() => {
      const knowledgeBaseSearchQueryLower = knowledgeBaseSearchQuery.value.toLowerCase()

      return kbContentData.filter(
        item =>
          // eslint-disable-next-line operator-linebreak
          item.title.toLowerCase().includes(knowledgeBaseSearchQueryLower) ||
          item.desc.toLowerCase().includes(knowledgeBaseSearchQueryLower),
      )
    })

    return {
      knowledgeBaseSearchQuery,
      kbContentData,
      filteredKB,
      icons: { mdiMagnify },
    }
  },
}
